<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-arrow-rise-square`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 4a2 2 0 012 2v36a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h40zm-2 4H6v32h36V8zm-17.114 4.616l6.928 8.382c.093.135.154.296.174.47l.006.066c.002.021.006.04.006.061l-.003.036a1.23 1.23 0 01-.018.175.973.973 0 01-.427.653c-.029.019-.06.03-.089.044-.015.007-.029.015-.044.021a.864.864 0 01-.089.03.866.866 0 01-.123.03c-.043.006-.085.013-.13.013H26.46v12.78a.62.62 0 01-.615.623h-3.692a.62.62 0 01-.616-.623v-12.78h-4.615c-.045 0-.087-.007-.141-.015a.938.938 0 01-.2-.058c-.016-.006-.03-.014-.045-.021-.03-.014-.06-.025-.089-.044-.232-.145-.378-.388-.431-.68a1.056 1.056 0 01-.014-.148L16 21.595c0-.02.004-.04.006-.06l.006-.066c.02-.175.081-.336.174-.471l6.928-8.382c.184-.347.543-.674.886-.607.343-.067.702.26.886.607z"/></svg>
</template>
<script>

export default {
  name: 'IconArrowRiseSquare',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
